import { Injectable } from '@angular/core';
import { BetonOrderConfirmErrorReasons } from '@beton/const';
import { BetonActions, BetonOrderApiService } from '@beton/data-access';
import { normalizeHttpError } from '@core/utils';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, catchError, map, of, switchMap } from 'rxjs';

@Injectable()
export class BetonOrderEffects {
  loadBetonOrderInitialData$: Observable<
    BetonActions.LoadBetonOrderInitialDataSuccess | BetonActions.LoadBetonOrderInitialDataFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType<BetonActions.LoadBetonOrderInitialData>(BetonActions.LOAD_BETON_ORDER_INITIAL_DATA),
      switchMap(() => {
        return this.betonOrderApiService.loadInitialData().pipe(
          map((data) => new BetonActions.LoadBetonOrderInitialDataSuccess(data)),
          catchError(() => of(new BetonActions.LoadBetonOrderInitialDataFail())),
        );
      }),
    ),
  );

  calculateBetonOrder$: Observable<BetonActions.CalculateBetonOrderSuccess | BetonActions.CalculateBetonOrderFail> =
    createEffect(() =>
      this.actions$.pipe(
        ofType<BetonActions.CalculateBetonOrder>(BetonActions.CALCULATE_BETON_ORDER),
        switchMap((action) => {
          return this.betonOrderApiService.calculateOrder(action.payload).pipe(
            map((data) => new BetonActions.CalculateBetonOrderSuccess(data)),
            catchError((error) => of(new BetonActions.CalculateBetonOrderFail(normalizeHttpError(error)))),
          );
        }),
      ),
    );

  confirmBetonOrder$: Observable<
    BetonActions.ConfirmBetonOrderSuccess | BetonActions.ConfirmBetonOrderFail | BetonActions.CalculateBetonOrder
  > = createEffect(() =>
    this.actions$.pipe(
      ofType<BetonActions.ConfirmBetonOrder>(BetonActions.CONFIRM_BETON_ORDER),
      switchMap((action) => {
        return this.betonOrderApiService.confirmOrder(action.payload).pipe(
          map((data) => new BetonActions.ConfirmBetonOrderSuccess(data)),
          catchError((error: any) => {
            // Необходимо произвести повторный рассчет в случае если
            // заявка не создается по причине изменения стоимости
            try {
              if (
                error.error.errors.some(
                  (i: any) => i.reason === BetonOrderConfirmErrorReasons.ValidationCalculationTotalPriceException,
                )
              ) {
                return [
                  new BetonActions.CalculateBetonOrder(action.payload),
                  new BetonActions.ConfirmBetonOrderFail(normalizeHttpError(error)),
                ];
              }
            } catch {
              new BetonActions.ConfirmBetonOrderFail(error);
            }

            return of(new BetonActions.ConfirmBetonOrderFail(normalizeHttpError(error)));
          }),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private betonOrderApiService: BetonOrderApiService,
  ) {}
}
